import { Observable, Subscription } from 'rxjs';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { getCenralLobySelectedLocationIds, getCentralLocationGridData, getCentralLocationGridFilters, State } from '../state';
import * as CentraLocationViewAction from '../state/actions/lobby-central-location-view.actions';
import { CentralLocationGridData } from '../shared/models/location-stat';
import { SortDescriptor } from '@progress/kendo-data-query';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { getCurrentTenant, getLobbyLocationSelected } from 'src/app/state';
import { LocationSelectorItem } from 'src/app/shared/models/location-selector/location-selector-item-model';
import { LocationStateModel } from 'src/app/shared/models/location-selector/location-state.model';
import { LocationMultiSelector } from 'src/app/shared/models/location-selector/location-multi-selector-model';
import * as CentralLocationSelectorActions from '../state/actions/lobby-central-view-location-selector.actions';
import { take } from 'rxjs/operators';
import * as CoreActions from 'src/app/state/actions/core.actions';
import { TranslationLoaderFacade } from 'src/app/admin/localization/translation-loader.facade';
@Component({
  selector: 'app-lobby-central-location-view',
  templateUrl: './lobby-central-location-view.component.html',
  styleUrls: ['./lobby-central-location-view.component.scss']
})
export class LobbyCentralLocationViewComponent implements OnInit, OnDestroy {
  sort: SortDescriptor[] = [
    {
      field: 'location.locationName',
      dir: 'asc'
    }
  ];

  centralLocationSubscriptions = new Subscription();
  public checkedKeys: any[] = [];
  public selectorDisable: boolean = false;
  gridData$?: Observable<CentralLocationGridData>;
  public gridView: GridDataResult | null = {} as GridDataResult;
  public pageSize: number=0;
  public skip: number=0;
  constructor(private store: Store<State>, private translationLoaderFacade: TranslationLoaderFacade) { }

  ngOnInit() {
    const gridDataSubscription = this.store.select(getCentralLocationGridData).subscribe((gridData)=>{
      this.gridView = {
        data: gridData.data ?? [],
        total: gridData.totalRowCount ?? 0
      };
      this.pageSize = gridData.pageSize ?? 1;
      this.skip = (gridData.currentPageNumber - 1) * this.pageSize
    });

    const tenantDetailSubscription = this.store.select(getCurrentTenant).pipe(take(1)).subscribe(
      (tenantInfo) => {       
        if (tenantInfo !== undefined && tenantInfo !== null) {
          this.store.dispatch(CentraLocationViewAction.setCentralLocationGridTenantId({tenantId: tenantInfo.tenantID}));
        }
      }
    );

    const locationDetailSubscription = this.store.select(getLobbyLocationSelected).pipe(take(1)).subscribe(
      (location) => {       
        if (location.locationId !== undefined && location.locationId !== null) {
          this.store.dispatch(CentraLocationViewAction.setCentralLocationGridLocationId({locationId: location.locationId}));
        }
      }
    );

    const gridFilterSubscription = this.store.select(getCentralLocationGridFilters).subscribe(
      gridFilters => {
        if (gridFilters !== null) {
         if(gridFilters.LocationFilters!=null && gridFilters.LocationFilters.length==0){
           gridFilters.LocationFilters.push(0);
         }
          this.store.dispatch(CentraLocationViewAction.subscribeToCentralLocationGridData({
            centralGridViewFilter: gridFilters
          }));
        }
      }
    );
    this.centralLocationSubscriptions.add(gridDataSubscription);
    this.centralLocationSubscriptions.add(tenantDetailSubscription);
    this.centralLocationSubscriptions.add(locationDetailSubscription);
    this.centralLocationSubscriptions.add(gridFilterSubscription);
  }
  public handleDefaultSelection(data: LocationMultiSelector) {
  
    var branchArray = data.locationsFlatData.filter(l => l.locationTypeId == 5);
    switch (branchArray.length) {
      case 0:
        this.selectorDisable = true;
        break;
      case 1:
        this.selectorDisable = true;
        this._setLocationSelectorDefaultValue();
        break;
      default:
        this._setLocationSelectorDefaultValue();
        break;
    }






  }
  private _setLocationSelectorDefaultValue() {
    const centralLocationIdsSubscription = this.store.select(getCenralLobySelectedLocationIds).pipe(take(1)).subscribe((location) => {

      this.checkedKeys = location;

    });
    this.centralLocationSubscriptions.add(centralLocationIdsSubscription);
  }
  public handleLocationData(items: LocationSelectorItem[] | any){   
    var locationStateArray:LocationStateModel[]=[];
    items.forEach(function(v: any){
      var locateStateObj:LocationStateModel={

        locationId:v.locationId,
        locationName:v.locationName,
        locationTypeId:v.locationTypeId
      };
      locationStateArray.push(locateStateObj);
     

     });
  if(locationStateArray.length<1){
    var locateStateObj:LocationStateModel={

      locationId:0,
      locationName:'',
      locationTypeId:0
    };
    locationStateArray.push(locateStateObj);

  }
    this.store.dispatch(CentralLocationSelectorActions.setCentralLocationSelectorItemSelectAll({selectedLocations: locationStateArray}));
    this.store.dispatch(CentraLocationViewAction.setCentralLocationGridPage({ page:1, pageSize: this.pageSize }));
    this.store.dispatch(CentralLocationSelectorActions.centralLocationSelectorItemChanged());
  }
  ngOnDestroy(): void {
    this.centralLocationSubscriptions.unsubscribe();    
    const groupNames = [      
      'CentralBranchGridGroup'
    ];
    this.store.dispatch(CoreActions.unsubscribeFromSignalRGroups({ groupNames }));
  }

  public pageChange(event: PageChangeEvent): void {
    const page = (event.skip / event.take) + 1;
    this.store.dispatch(CentraLocationViewAction.setCentralLocationGridPage({ page, pageSize: event.take }));
  }

  sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    let field = '';
    switch (sort[0].field) {
      case 'location.locationName':
        field = 'Location.LocationName';
        break;
      case 'currentWaitTime':
        field = 'CurrentWaitTime';
        break;
      case 'visitorsWaiting':
        field = 'VisitorsWaiting';
        break;
      case 'visitorServed':
        field = 'VisitorServed';
        break;
      case 'serviceProvided':
        field = 'ServiceProvided';
        break;
      case 'avgAssistTime':
        field = 'AvgAssistTime';
        break;
      case 'avgWaitTime':
        field = 'AvgWaitTime';
        break;
      case 'abandoned':
        field = 'Abandoned';
        break;
    }
    this.store.dispatch(CentraLocationViewAction.setCentralLocationGridSort({ sortColumn: field, sortDirection: sort[0].dir == undefined ? 'asc' : sort[0].dir }));
  }


  public closeLeftWithoutAssistant() {

  }

}
